export default "__VITE_ASSET__Dm2bAC5R__"